export enum ActionTypes {
  nextStep = 'NEXT_STEP',
  nextMainStep = 'NEXT_MAIN_STEP',
  addStep = 'ADD_STEP',
  prevStep = 'PREV_STEP',
  setParamsToCurrentStep = 'SET_PARAMS_TO_CURRENT_STEP',
}
